import { authMessages } from "./auth";
import { commonMessages } from "./common";
import { dashboardMessages } from "./dashboard";
import { financeMessages } from "./finance";
import { landingMessages } from "./landing";
import { marketMessages } from "./market";
import { shellMessages } from "./shell";
import { legalMessages } from "./legal";

/** Every namespace, keyed by the prefix its keys must start with (enforced by i18n.test.ts). */
export const NAMESPACES = {
  common: commonMessages,
  nav: shellMessages,
  landing: landingMessages,
  auth: authMessages,
  market: marketMessages,
  finance: financeMessages,
  dashboard: dashboardMessages,
  legal: legalMessages
};
